// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cff5982e","239":"5e259d15","455":"f188776e"}[chunkId] + ".chunk.js";
};